import { createReducer } from '../../utils';

export const initialState = {
    session: {
        expireAt: null,
        accessToken: null,
        refreshToken: null
    },
    logger: null
};

const ACTION_HANDLERS = { };

export default createReducer(ACTION_HANDLERS, initialState);
